import { render, staticRenderFns } from "./creative-audit-modal.vue?vue&type=template&id=a95ac0b8&scoped=true"
import script from "./creative-audit-modal.vue?vue&type=script&lang=js"
export * from "./creative-audit-modal.vue?vue&type=script&lang=js"
import style0 from "./creative-audit-modal.vue?vue&type=style&index=0&id=a95ac0b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ac0b8",
  null
  
)

export default component.exports